import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { AlertSubscriptionAction } from '../alertSubscription.action';

export const AlertsDataSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AlertSubscriptionAction.loadSubscriptions.started());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(AlertSubscriptionAction.destroy());
    };
  }, [dispatch]);

  return null;
};
